import axios from "axios";
import join from "lodash/join";
import split from "lodash/split";
import forEach from "lodash/forEach";

import { adminUrl, PAGES } from "../config/constants";
import { BORROWER } from "../constants/contact_id_status";

export const saveContact = () => async (dispatch, getState) => {
  const { contacts, forBorrower } = getState().form;
  const { userId, userId2 } = getState().user;
  const borrowerInfo = getState().borrowerInfo;

  const formData = new FormData();

  formData.append("action", "saveContact");
  formData.append("userId", userId);

  if (userId2) {
    formData.append("userId2", userId2);
  }

  formData.append("backButton", borrowerInfo.backButton);

  if (contacts.id_status !== BORROWER.value) {
    formData.append("for_borrower_first_name", forBorrower.first_name);
    formData.append("for_borrower_last_name", forBorrower.last_name);

    let phone_mobile1 = forBorrower.phone_mobile;

    phone_mobile1 = join(split(phone_mobile1, " "), "");
    phone_mobile1 = join(split(phone_mobile1, "-"), "");
    phone_mobile1 = join(split(phone_mobile1, "("), "");
    phone_mobile1 = join(split(phone_mobile1, ")"), "");

    formData.append("for_borrower_phone_mobile", phone_mobile1);
    formData.append("for_borrower_email", forBorrower.email);
  }

  // save 9 fields
  forEach(borrowerInfo, (val, field) => {
    formData.append(field, val);
  });

  forEach(contacts, (val, field) => {
    if (val !== "") {
      formData.append(field, val);
    }
  });

  dispatch({
    type: "SET_PAGE",
    payload: PAGES.PROPERTY_ADDRESS,
  });

  const { data } = await axios.post(adminUrl, formData);

  dispatch({
    type: "SET_USER",
    payload: data,
  });
};



// WEBPACK FOOTER //
// ./src/actions/saveContact.actions.js